import React        from 'react';


class Footer extends React.Component{

    state = {
        prevProps: {},
        showTask: false,
        showHint: false,
        task:  null,
        points: 0
    }


    showContent =(c, ui)=>{
        this.props.showContent(c , ui);
    }


    render(){   
 
        const btn_task = <button
            onClick={()=> this.showContent('showTask', true)}
            id="btnMain"
            className={"btn-primary " + (this.props.current_content === 'showTask' ? 'btn-active' : '')}
            ><i className="material-icons">{(this.props.current_content === 'showTask' ? '360' : 'keyboard_arrow_right')}</i></button>

        const btn_hint = <button
            onClick={()=> this.showContent('showHint', true)}
            id="btnHint"
            className={(this.props.current_content === 'showhint' ? 'btn-active' : '')}
            ><i className="material-icons">star_half</i></button>

        let btn_next = <button
            onClick={()=>(this.props.counter + 1 >= this.props.counter_max ? this.props.goSuccess() : this.props.start(this.props.counter+1))}
            id="btnMain"
            ><i className="material-icons">keyboard_arrow_right</i></button>   

            if(this.props.missionended) btn_next = <button
                id="btnMain"
                className="btn-cta"
                onClick={this.props.newGame}
                ><i className="material-icons">play_arrow</i></button>   

        let currentBtn = '';//btn_task;

            if(this.props.ui_locked && this.props.task_ended) currentBtn = btn_next;

            if(currentBtn === '' && this.props.current_content !== 'showHint' && this.props.current_content !== 'showInfo') currentBtn = btn_task;//stupid manual overrides here

            if(this.props.custombutton) currentBtn = this.props.custombutton;

        return(
            <footer className="block-element">
                {(this.props.missionended ? <div className="ui-guide-message"><span>Play again?</span></div> : '')}
                <a id="footerLogo" href="https://colovr.com" target="_blank" rel="noopener noreferrer"><span>Made with </span>coloVR&deg;</a>
                {currentBtn}
                {(this.props.ui_locked || this.props.hide_hint ? '' : btn_hint)}
            </footer>
        )
    }
}


export default Footer;